import axiosInstance from "@/middlewares/Routing.middleware";
import { Module } from "../interfaces/Module.interface";

export async function GetCustomFields(name: string): Promise<Module> {
  return (await axiosInstance.get(`/modules?name=${name}`)).data;
}
